import { Map } from 'immutable';

import * as constants from '../types';
import { SelectedBaselineJobInfo } from '../../../records';
import { parseSelectedJobMetricsValue } from '../../../utils';

const initialState = Map({
  selectedBaselineChartPayload: null,
  loadingJobData: true,
  jobInfo: new SelectedBaselineJobInfo(),
  failure: null,
});

const selectedBaselineJobReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case constants.GET_SELECTED_BASELINE_JOB_DATA.REQUEST: {
      return state.withMutations((newState) => {
        newState
          .set('jobInfo', new SelectedBaselineJobInfo())
          .set('loadingJobData', true)
          .set('failure', null);
      });
    }
    case constants.GET_SELECTED_BASELINE_JOB_DATA.SUCCESS: {
      return state.withMutations((newState) => {
        newState
          .set('jobInfo', new SelectedBaselineJobInfo({
            url: payload.page_url,
            timestamp: payload.timestamp,
            metrics: parseSelectedJobMetricsValue(payload.metric_data, payload.perfType),
          }))
          .set('loadingJobData', false);
      });
    }
    case constants.GET_SELECTED_BASELINE_JOB_DATA.FAILURE: {
      return state.withMutations((newState) => {
        newState
          .set('failure', payload)
          .set('loadingJobData', false);
      });
    }
    case constants.UPDATE.SELECTED_BASELINE_CHART_DATA_POINT:
      return state.set('selectedBaselineChartPayload', payload);
    case constants.CLEANUP:
      return initialState;
    default:
      return state;
  }
};

export default selectedBaselineJobReducer;
export { initialState };
